import reducer from './reducer'

import * as assignmentsOperations from './operations'
import * as assignmentsSelectors from './selectors'

export { assignmentsOperations, assignmentsSelectors }

export default reducer
